import vdcsLogo from "@/assets/vdcs-logo.webp";
import lucianoAvatar from "@/assets/luciano-vdcs-founder.webp";
import {
  Attribution,
  QuoteCard,
  useInViewRef,
} from "@/components/sections/testimonial/shared";

export function Step7Testimonial() {
  const { ref } = useInViewRef<HTMLElement>();

  return (
    <section ref={ref} className="flex flex-col">
      <h2 className="text-3xl font-bold tracking-tight text-foreground">
        Made back the investment in{" "}
        <span className="text-gradient-cycle font-bold">3 weeks.</span>
      </h2>

      <QuoteCard>
        I was nervous about the monthly cost but one new client from the site
        paid for{" "}
        <span className="text-gradient-cycle font-bold">6 months.</span> Totally
        worth it.
      </QuoteCard>

      <Attribution
        avatarSrc={lucianoAvatar}
        avatarAlt="Luciano Meireles"
        name="Luciano Meireles"
        role="Founder, VDCS"
        logoSrc={vdcsLogo}
        logoAlt="Virtual Design Construction Solutions logo"
        logoClassName="h-8"
      />
    </section>
  );
}
